// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dataset-field-list {
  display: flex;
  height: 100%;
}
.dl-dataset-field-list__field {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-inline: var(--dl-dataset-field-list-item-padding-inline);
  cursor: pointer;
}
.dl-dataset-field-list__field-title {
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dl-dataset-field-list__field-icon, .dl-dataset-field-list__formula-icon {
  flex-shrink: 0;
}
.dl-dataset-field-list__field-icon {
  margin-right: 10px;
}
.dl-dataset-field-list__formula-icon {
  color: var(--g-color-text-secondary);
  margin-right: 5px;
}
.dl-dataset-field-list .g-list .g-list__filter {
  padding: var(--dl-dataset-field-filter-padding);
}

:root {
  --dl-dataset-field-list-item-padding-inline: 32px;
  --dl-dataset-field-filter-padding: unset;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DatasetFieldList/DatasetFieldList.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,YAAA;AACJ;AACI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gEAAA;EACA,eAAA;AACR;AAEI;EACI,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAGI;EAEI,cAAA;AAFR;AAKI;EACI,kBAAA;AAHR;AAMI;EACI,oCAAA;EACA,iBAAA;AAJR;AAOI;EACI,+CAAA;AALR;;AASA;EACI,iDAAA;EACA,wCAAA;AANJ","sourcesContent":[".dl-dataset-field-list {\n  display: flex;\n  height: 100%;\n}\n.dl-dataset-field-list__field {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding-inline: var(--dl-dataset-field-list-item-padding-inline);\n  cursor: pointer;\n}\n.dl-dataset-field-list__field-title {\n  flex-grow: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.dl-dataset-field-list__field-icon, .dl-dataset-field-list__formula-icon {\n  flex-shrink: 0;\n}\n.dl-dataset-field-list__field-icon {\n  margin-right: 10px;\n}\n.dl-dataset-field-list__formula-icon {\n  color: var(--g-color-text-secondary);\n  margin-right: 5px;\n}\n.dl-dataset-field-list .g-list .g-list__filter {\n  padding: var(--dl-dataset-field-filter-padding);\n}\n\n:root {\n  --dl-dataset-field-list-item-padding-inline: 32px;\n  --dl-dataset-field-filter-padding: unset;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
